/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Button, Select, Radio } from "antd";
import { HeaderWithBottomLine } from "../HeaderWithBottomLine";
import {
  checkSpecialCharacter,
  checkSpace,
  checkAlphabets,
  capitalise,
} from "../../../../utils";
import API from "../../../../api";
import { APIs } from "../../../../utils/worker";
import urls from "../../../../api/urls";
import { ReactComponent as Reason } from "../../../../assests/images/SVG/check.svg";

const { VERIFY_GST } = urls;

function FirmInputDetails({ form, editDetails, itemkey, apiResponse }) {
  const radioGap = {
    display: "flex",
    columnGap: "4rem",
  };
  const [isGstAnabel, setIsGstAnabel] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);

  useEffect(() => {
    setIsGstAnabel(apiResponse?.miscellaneousDto?.gstRegistred);
  }, [apiResponse]);

  useEffect(() => {
    if (itemkey === 1) {
      setIsGstAnabel(JSON.parse(editDetails?.IsGSTRegistered));
    }
  }, [itemkey]);

  const checkGST = async (event) => {
    if (event.target.value.length > 14) {
      let response = await API.Api(
        VERIFY_GST + event.target.value.toUpperCase()
      ).get();
      if (response.status) {
        if (response.response) {
          setCheckStatus(true);
          form.setFieldValue(
            "NameOfFirm",
            response?.response?.data?.result?.gstnDetailed?.legalNameOfBusiness
          );
          form.setFieldValue(
            "PANNumber",
            extractPAN_Number(event.target.value.toUpperCase())
          );
          // form.setFieldValue("gstin", event.target.value.toUpperCase());
          // let clientName = form.getFieldValue("clientName");
          // console.log(clientName);
        }
      }
    } else {
      setCheckStatus(false);
    }
  };

  let lg = 12;
  let sm = 24;
  let md = 12;
  let xs = 24;

  function validateInput(rule, value, callback) {
    if (/^\s/.test(value)) {
      callback("Input cannot start with a space!");
    } else {
      callback();
    }
  }

  function extractPAN_Number(str) {
    var strPattern = ["[A-Z]{5}[0-9]{4}[A-Z]{1}"];
    for (var i = 0; i < 1; i++) {
      var pattern = new RegExp(strPattern[i]);
      var matcher = pattern.exec(str);
      if (matcher != null) {
        // console.log(matcher[0])
        return matcher[0];
      }
    }
  }

  return (
    <>
      <HeaderWithBottomLine text={"Tax Information"} icon={false} />

      <Row gutter={40} className="basic-details-conten global-form-row">
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="nameOfProprietor"
            label={"Name of proprietor / partner"}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
              { validator: validateInput },
              // {
              //   pattern:/^\s*$/.test(yourString)
              // }
              // () => ({
              //   validator(rule, value = "") {
              //     if (value.substring(1, 0) === " ") {
              //       return Promise.reject("Invalid proprietor / partner name");
              //     } else {
              //       return Promise.resolve();
              //     }
              //   },
              // }),
            ]}
            onKeyPress={(event) => {
              if (checkAlphabets(event)) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter proprietor / partner name"
              type="text"
              maxLength={35}
              // onInput={(e) => upperCase(e)}
              // style={{ textTransform: "capitalize" }}
              onBlur={(e) =>
                form.setFieldValue("nameOfProprietor", capitalise(e))
              }
            />
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="IsGSTRegistered"
            label={
              <span className="calculater-container-pikpin">
                Is GST registered
              </span>
            }
          >
            <Radio.Group
              style={radioGap}
              onChange={(e) => setIsGstAnabel(JSON.parse(e.target.value))}
              defaultValue={"false"}
              value={isGstAnabel}
              rules={[
                {
                  required: true,
                  message: "Please select value",
                },
              ]}
            >
              <Radio value="true">Yes</Radio>
              <Radio value="false">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        {isGstAnabel ? (
          <>
            {" "}
            <Col lg={lg} md={md} sm={sm} xs={xs}>
              <Form.Item
                name="GSTnumber"
                label={"GST number"}
                // className="input-drop-down"
                className="accpickupPincodeParent"
                onKeyPress={(event) => {
                  if (checkSpecialCharacter(event) || checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    message: "Please enter GSTIN",
                    required: true,
                  },
                  {
                    pattern:
                      /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/g,
                    message: "Invalid GSTIN",
                  },
                ]}
              >
                <Input
                  placeholder="Enter GST number"
                  className="accpickupPincode"
                  type="text"
                  maxLength={15}
                  onChange={checkGST}
                  suffix={checkStatus ? <Reason /> : ""}
                  onKeyPress={(e) => {
                    if (/[^A-Za-z0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col lg={lg} md={md} sm={sm} xs={xs}>
              <Form.Item
                name="NameOfFirm"
                label={"Name of firm (as per GST)"}
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                  },
                ]}
                onKeyPress={(event) => {
                  if (checkAlphabets(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Enter firm name"
                  type="text"
                  disabled={true}
                />
              </Form.Item>
            </Col>{" "}
          </>
        ) : (
          <Col lg={lg} md={md} sm={sm} xs={xs}>
            <Form.Item
              name="NameOfFirm"
              label={"Name of firm"}
              rules={[
                {
                  required: true,
                  message: "Please enter value",
                },
              ]}
              onKeyPress={(event) => {
                if (checkAlphabets(event)) {
                  event.preventDefault();
                }
              }}
            >
              <Input placeholder="Enter firm name" type="text" />
            </Form.Item>
          </Col>
        )}

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="FirmType"
            label={
              <span className="calculater-container-pikpin">Firm type</span>
            }
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
          >
            <Select
              className="app-selector"
              placeholder="Select firm type"
              options={[
                {
                  value: "Proprietor",
                  label: "Proprietor",
                },
                {
                  value: "Partnership",
                  label: "Partnership",
                },
                {
                  value: "HUF",
                  label: "HUF",
                },
                {
                  value: "LLP",
                  label: "LLP",
                },
                {
                  value: "Pvt Ltd",
                  label: "Pvt Ltd",
                },
              ]}
            />
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs} className="input-drop-down">
          <Form.Item
            name="MSME"
            label="MSME"
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
            initialValue={"false"}
          >
            <Radio.Group style={radioGap}>
              <Radio value="true">Yes</Radio>
              <Radio value="false">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="PANNumber"
            label={
              <span className="calculater-container-pikpin">PAN number</span>
            }
            onKeyPress={(event) => {
              if (checkSpecialCharacter(event) || checkSpace(event)) {
                event.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },

              {
                pattern: new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/g),
                message: "Please enter a valid PAN number",
                validateTrigger: "onSubmit",
              },
            ]}
          >
            <Input
              placeholder="Enter PAN number"
              type="text"
              maxLength={10}
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default FirmInputDetails;
